import useSalutations from 'components/impfschaeden/assistent/VaxForm_02_Benutzerinformation/hooks/useSalutations.js';
import useTitles from 'components/impfschaeden/assistent/VaxForm_02_Benutzerinformation/hooks/useTitles.js';
import PropTypes from 'prop-types';

import { useTranslation } from 'next-i18next';
import {
	Card,
	Stack,
	Input,
	DropdownSelect,
	FormGroup,
	SearchSelect,
} from 'components/ui';

const Benutzerdaten = ({
	updateUser,
	formData,
	validation,
	integratedTitle,
	edit,
}) => {
	const titleOptions = useTitles();
	const salutationOptions = useSalutations();
	const [t] = useTranslation();
	return (
		<>
			{integratedTitle && <Card.Title>{integratedTitle}</Card.Title>}
			<FormGroup className='mb-3'>
				<Stack gap={3}>
					<DropdownSelect
						disabled={edit}
						className='w-100'
						aria-label={t('common.anrede')}
						onChange={(e) =>
							updateUser({
								user_salutation_id: e.target.value,
							})
						}
						value={formData?.user?.user_salutation_id}
						isInvalid={validation['user_salutation_id']}
						options={salutationOptions}
					/>
					<SearchSelect
						disabled={edit}
						className='w-100'
						options={titleOptions}
						displayProperty='title'
						value={
							titleOptions.find((title) => {
								return formData?.user?.title == title.title;
							}) ||
							formData?.user?.title ||
							''
						}
						label={t('nutzerbereich.registrieren.titel')}
						onChange={(newValue) => {
							if (typeof newValue === 'string') {
								const existing = titleOptions.find((title) => {
									return title.user_title_id === newValue;
								});
								if (existing) {
									updateUser({
										title: existing.user_title_id,
									});
								} else {
									updateUser({ title: newValue });
								}
							}
						}}
						isInvalid={validation['title']}
					/>
					<Input
						disabled={edit}
						className='w-100'
						type='text'
						label={t('nutzerbereich.registrieren.vorname') + ' *'}
						value={formData?.user?.first_name}
						onChange={(e) => {
							updateUser({
								first_name: e.target.value,
							});
						}}
						aria-autocomplete='list'
						isInvalid={validation['first_name']}
					/>
					<Input
						disabled={edit}
						className='w-100'
						type='text'
						label={t('nutzerbereich.registrieren.nachname_oder_kuerzel') + ' *'}
						value={formData?.user?.last_name}
						onChange={(e) => {
							updateUser({
								last_name: e.target.value,
							});
						}}
						isInvalid={validation['last_name']}
					/>
					<Input
						disabled={edit}
						className='w-100'
						type='email'
						label={t('nutzerbereich.registrieren.email') + ' *'}
						value={formData?.user?.email}
						onChange={(e) => {
							updateUser({
								email: e.target.value,
							});
						}}
						isInvalid={t(validation['email'])}
					/>
				</Stack>
			</FormGroup>
		</>
	);
};

Benutzerdaten.propTypes = {
	formData: PropTypes.object,
	updateUser: PropTypes.func,
	validation: PropTypes.object,
	integratedTitle: PropTypes.string,
	edit: PropTypes.bool,
};

export { Benutzerdaten };
